import { render, staticRenderFns } from "./indexlist.vue?vue&type=template&id=436986bc&scoped=true"
import script from "./indexlist.vue?vue&type=script&lang=js"
export * from "./indexlist.vue?vue&type=script&lang=js"
import style0 from "./indexlist.vue?vue&type=style&index=0&id=436986bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436986bc",
  null
  
)

export default component.exports